export default {
  /**
   * 分類と商品条件の標準フォーマット
   */
  get() {
    return {
      /**
       * @see store.js
       */
      key: new Date().getTime().toString(),
      /**
       * 選択モード分類:category / 商品(商品指定):item / 商品(分類指定):itemCategory）
       */
      selectMode: 'category',
      /**
       * 企業コード
       */
      company: undefined,

      category: {
        /**
         * 企業コード
         */
        company: undefined,
        /**
         * 分類階層
         */
        itemCategoryLevel: undefined,
        /**
         * 選択分類（最下層）一覧
         */
        categories: [],
        /**
         * 分類指定、商品選択での新商品絞り込み
         */
        filterNewItems: false,
        /**
         * 入力エラー
         */
        errors: [],
      },
      item: {
        /**
         * 企業コード
         */
        company: undefined,
        /**
         * 選択分類（最下層）一覧
         */
        categories: [],
        /**
         * 選択商品一覧
         */
        items: [],
        /**
         * 商品グループID
         */
        itemGroupId: undefined,
        /**
         * 分類指定、商品選択での新商品絞り込み
         */
        filterNewItems: false,
        /**
         * 入力エラー
         */
        errors: [],
      },
      /**
       * 入力エラー
       */
      errors: [],
    }
  },
  /**
   * 分析APIで使用する分類のフォーマットに変換する
   */
  mapToApiPayload(categoryItemCategory) {
    if (categoryItemCategory.selectMode === 'category') {
      return {
        company: categoryItemCategory.company,
        categories: categoryItemCategory.category.categories,
        itemCategoryLevel: categoryItemCategory.category.itemCategoryLevel,
        filterNewItems: categoryItemCategory.category.filterNewItems,
      }
    } else if (categoryItemCategory.selectMode === 'item') {
      return {
        company: categoryItemCategory.company,
        items: categoryItemCategory.item.items.map(i => i.code),
        itemGroupId: categoryItemCategory.item.itemGroupId,
      }
    } else if (categoryItemCategory.selectMode === 'itemCategory') {
      return {
        company: categoryItemCategory.company,
        categories: categoryItemCategory.item.categories,
        filterNewItems: categoryItemCategory.item.filterNewItems,
      }
    }

    throw new Error(
      `unknown item select mode: ${categoryItemCategory.selectMode}`,
    )
  },
  /**
   * applyToに対してtermを適用する
   */
  applyPayload(applyTo, item) {
    applyTo.key = new Date().getTime().toString()
    applyTo.company = item.company
    // 商品選択を適用する
    // ※ 強制的に商品表示になってしまうけど安直なパターン
    if (!item.category && !item.item) {
      switch (item.selectMode) {
        case 'category':
          applyTo.selectMode = 'itemCategory'
          applyTo.item.categories = item.categories
          applyTo.item.filterNewItems = item.filterNewItems
          break
        case 'item':
          applyTo.selectMode = 'item'
          applyTo.item.items = item.items
          applyTo.item.itemGroupId = item.itemGroupId
          break
      }
      return
    }

    applyTo.selectMode = item.selectMode
    applyTo.company = item.company
    applyTo.category.company = item.category.company
    applyTo.category.itemCategoryLevel = item.category.itemCategoryLevel
    applyTo.category.categories = item.category.categories
    applyTo.category.filterNewItems = item.category.filterNewItems
    applyTo.item.company = item.item.company
    applyTo.item.categories = item.item.categories
    applyTo.item.items = item.item.items
    applyTo.item.itemGroupId = item.item.itemGroupId
    applyTo.item.filterNewItems = item.item.filterNewItems
  },
}
